"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DateTimePGHandler", {
    enumerable: true,
    get: function() {
        return DateTimePGHandler;
    }
});
const _datetimegeneralhandler = require("./date-time.general.handler");
let DateTimePGHandler = class DateTimePGHandler extends _datetimegeneralhandler.DateTimeGeneralHandler {
    async parseUserInput(params) {
        const knex = params.options.baseModel.dbDriver;
        const dayjsUtcValue = super.parseDateTime(params).value;
        // convert to UTC
        // e.g. 2023-01-01T12:00:00.000Z -> 2023-01-01 12:00:00+00:00
        // then convert to db timezone
        const val = dayjsUtcValue ? knex.raw(`? AT TIME ZONE CURRENT_SETTING('timezone')`, [
            dayjsUtcValue.format('YYYY-MM-DD HH:mm:ssZ')
        ]) : undefined;
        return {
            value: val
        };
    }
};
